{
    "ClientConfigurationModal_AddTitle": "Ajouter une configuration client",
    "ClientConfigurationModal_ChangeTitle": "Modifier la configuration du client",
    "ClientConfigurationModal_Footer_Actions_Submit": "Soumettre",
    "ClientConfigurationModal_Footer_Actions_Cancel": "Annuler",
    "ClientConfigurationModal_Footer_Actions_Help": "Aide",
    "ClientConfigurationModal_Tabs_Details": "Détails",
    "ClientConfigurationModal_Tabs_Scope": "Portée",
    "ClientConfigurationModal_Tabs_Policy": "Politique",
    "ClientConfigurationModal_Tabs_Settings": "Paramètres",
    "ClientConfigurationModal_Tab_Details_Description": "Description",
    "ClientConfigurationModal_Tab_Details_Description_Required": "La description est obligatoire",
    "ClientConfigurationModal_Tab_Details_ID": "IDENTIFIANT",
    "ClientConfigurationModal_Tab_Details_ID_Placeholder": "[Attribué automatiquement]",
    "ClientConfigurationModal_Tab_Details_Override": "Remplacer la configuration de tous les clients",
    "ClientConfigurationModal_Tab_Scope_CME": "FMC",
    "ClientConfigurationModal_Tab_Scope_Telsys": "Serveur de téléphonie",
    "ClientConfigurationModal_Tab_Scope_Telsys_Required": "Un serveur de téléphonie est requis",
    "ClientConfigurationModal_Tab_Scope_Partition": "Partition",
    "ClientConfigurationModal_Tab_Scope_Device": "Appareil",
    "ClientConfigurationModal_Tab_Scope_FilterRecursive": "Filtrer récursivement",
    "ClientConfigurationModal_Tab_Policy_PolicyItem": "Élément de politique",
    "ClientConfigurationModal_Tab_Policy_DefaultValue": "Valeur par défaut",
    "ClientConfigurationModal_Tab_Policy_ActualValue": "Valeur réelle",
    "ClientConfigurationModal_Policy_core": {
        "showUseConfigurationWindow": "Noyau - Peut afficher\/utiliser la fenêtre de configuration",
        "permittedToLogin": "Noyau - Autorisé à se connecter"
    },
    "ClientConfigurationModal_Policy_configOptions": {
        "useLocalhostAPI": "Configuration - utiliser l'API Localhost",
        "canConfigureCustomEvents": "Configuration - Configurer les événements personnalisés"
    },
    "ClientConfigurationModal_Policy_menuOptions": {
        "canShowAddressBook": "Menu - Carnet d'adresses"
    },
    "ClientConfigurationModal_Policy_crm": {
        "canAddNewContacts": "Peut ajouter de nouveaux contacts aux CRM (via l'assistant)"
    },
    "ClientConfigurationModal_Tab_Settings_SettingsItem": "Option de réglage",
    "ClientConfigurationModal_Tab_Settings_DefaultValue": "Valeur par défaut",
    "ClientConfigurationModal_Tab_Settings_ActualValue": "Valeur réelle",
    "ClientConfigurationModal_Settings_interface": {
        "showCallNotificationPreview": "Interface - Afficher l'aperçu de la notification d'appel",
        "showMissedCallPreview": "Interface - Afficher l'aperçu des appels manqués",
        "connectedHideDelay": "Interface - Délai de masquage connecté",
        "previewWindowAlwaysOnTop": "Interface - Fenêtre d'aperçu toujours visible",
        "showContactInEditMode": "Interface - Afficher le contact en mode édition",
        "applicationLoadAtWindowsStartup": "Interface - Chargement de l'application au démarrage de Windows"
    },
    "ClientConfigurationModal_Settings_hotkey": {
        "makeCall": "Raccourci clavier - Passer un appel"
    },
    "ClientConfigurationModal_Settings_dialing": {
        "clipboardDialing": "Numérotation - Numérotation via le presse-papiers",
        "focusDialing": "Numérotation - Numérotation ciblée",
        "screenDialing": "Numérotation - Numérotation à l'écran"
    },
    "ClientConfigurationModal_Settings_logPage": {
        "sendAnonymouseStats": "Page de journal - Envoyer des statistiques anonymes",
        "loggingLevel": "Page de journalisation - Niveau de journalisation",
        "sendAnonymousStats": "Page de journal - Envoyer des statistiques anonymes"
    },
    "ClientConfigurationModal_Settings_version": {
        "checkForUpdates": "Version - Rechercher les mises à jour et télécharger"
    },
    "NAME": "ClientConfigurationModalLanguage",
    "ClientConfigurationModal_Error_NotFound": "La configuration du client est introuvable ou n'existe pas"
}